import React from 'react';
import CustomerEngagementReport from './CustomerEngagementReport';
export default function AbandonedCartsReport() { return <CustomerEngagementReport mode="abandoned"/>; }
